export class FlavorFilter {
    public IncludeInactive?: boolean;
    public IncludeFountainAvailableOnly?: boolean;
}

export default FlavorFilter;